<template>
  <v-row
    class="elevation-4 px-4 mx-1 py-1 mb-4 mt-n2 white"
    dense
  >
    <v-col cols="6">
      <b class="text-capitalize">{{ label }}</b>
    </v-col>
    <v-col cols="6">
      <v-btn
        @click.stop="edit"
        class="float-right"
        icon
        color="ternary"
      >
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="12">
      <v-chip
        color="grey lighten-2"
        class="px-5 pt-0 mr-1 my-1 primary--text font-weight-bold"
      >
        {{ $t(`scenario.${value}`) }}
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'EditableChipBlock',

  props: {
    value: {
      type: String,
      required: true,
      default: '',
    },
    label: {
      type: String,
      required: true,
      default: '',
    }
  },

  methods: {
    edit () {
      this.$emit('edit');
    },
  },
};
</script>